module.exports = __webpack_public_path__ + "img/KH.393f7ffe.png";